import React from 'react';
import { useDispatch } from 'react-redux';
import { Anchor } from 'antd';
import { CampaignType, EarningRuleRewardType } from 'config/CustomEnums';
import './AnchorPage.scss';
import { getShowDisplayInFrontend } from 'models/CreateCampaignModel';
import {
  getContentPageAnchor,
  getEarningRuleAnchor,
  getCouponCampaignRulePageAnchor,
  getCouponPageAnchor,
  handleClick,
  AnchorSubTitle,
} from './AnchorPage';
import { CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY } from 'config/PageAnchorConfig/CampaignAnchorConfig';

const { Link } = Anchor;

const DetailAnchorPage = ({
  detailData,
}) => {
  const dispatch = useDispatch();
  const campaign = detailData || {};

  const {
    campaignType,
    displayInFrontend,
    haveCreatedCoupon,
  } = campaign;
  const earningRuleType = campaign.linkedEarningRules?.type;
  const earningRuleRewardType = campaign.linkedEarningRules?.rewardType;

  let shouldlinkCoupon = false;
  if (
    campaignType === CampaignType.earningRulesCampaign
    && earningRuleRewardType === EarningRuleRewardType.coupons
  ) {
    shouldlinkCoupon = true;
  } else if (
    campaignType === CampaignType.couponsCampaign
  ) {
    shouldlinkCoupon = true;
  };

  const haveLinkedCoupon = shouldlinkCoupon && haveCreatedCoupon;
  const stepWithCoupon = shouldlinkCoupon && !haveCreatedCoupon;

  const showDisplayInFrontend = getShowDisplayInFrontend(campaignType, earningRuleType);
  const hideInFrontend = showDisplayInFrontend && !displayInFrontend && showDisplayInFrontend !== undefined;

  const contentPageAnchor = getContentPageAnchor(hideInFrontend, campaign.campaignType);
  const isEarningCampaign = campaign.campaignType === CampaignType.earningRulesCampaign;
  const isCouponCampaign = campaign.campaignType === CampaignType.couponsCampaign;
  const earningRuleAnchor = getEarningRuleAnchor(campaign.linkedEarningRules?.type);
  const couponPageAnchor = getCouponPageAnchor();
  const couponCampaignShowLimit = isCouponCampaign && campaign?.showCouponLimit
  const couponCampaignRulePageAnchor = getCouponCampaignRulePageAnchor(couponCampaignShowLimit);

  return (
    <div className='anchor-page-container'>
      <div className='anchor-page-navigation-container'>
        <label className="create-section-title anchor-page-title">
          NAVIGATION
        </label>
      </div>

      <Anchor
        offsetTop={90}
        onClick={(e, link) => handleClick(e, link, dispatch)}
      >
        {
          haveLinkedCoupon && (
            <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.linkedCoupon}`} title="Coupon set" />
          )
        }
        <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.contentPage}`} title="Content" >
          {
            contentPageAnchor.map(item => (
              <AnchorSubTitle item={item} errorSectionList={[]} />
            ))
          }
        </Link>
        {
          isEarningCampaign && (
            <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.earningRulePage}`} title="Rule & Properties" >
              {
                earningRuleAnchor.map(item => (
                  <AnchorSubTitle item={item} errorSectionList={[]} />
                ))
              }
            </Link>
          )
        }
        {
          isCouponCampaign && (
            <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.earningRulePage}`} title="Rule & Properties" >
              {
                couponCampaignRulePageAnchor.map(item => (
                  <AnchorSubTitle item={item} errorSectionList={[]} />
                ))
              }
            </Link>
          )
        }
        {stepWithCoupon && <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.couponPage}`} title="Coupon set" >
          {
            couponPageAnchor.map(item => (
              <AnchorSubTitle item={item} errorSectionList={[]} />
            ))
          }
        </Link>}
        <Link className='anchor-title' href={`#${CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.detailGeneral}`} title="General" />
      </Anchor>
    </div>
  );
};

export default DetailAnchorPage;
